function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Theme from '@adsk/alloy-react-theme';
export const accordionItem = {
  backgroundColor: Theme.colors.white
};
export const accordionContainer = {
  marginLeft: '28px'
};
export const titleText = _objectSpread(_objectSpread({}, Theme.typography.bodyMediumBold), {}, {
  color: Theme.colors.charcoal900
});
export const secondaryText = _objectSpread(_objectSpread({}, Theme.typography.bodySmall), {}, {
  color: Theme.colors.charcoal900
});
export const labelText = _objectSpread(_objectSpread({}, Theme.typography.caption), {}, {
  color: Theme.colors.charcoal700
});
export const footer = {
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '28px'
};
export const footerSideText = _objectSpread({}, Theme.typography.bodySmallBold);
export const footerDateText = _objectSpread(_objectSpread({}, labelText), {}, {
  marginRight: '16px'
});
//# sourceMappingURL=styles.js.map